<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useKpiStore } from '@/stores/useKpiStore'
import ChartBar from '@/components/data-visualization/charts/ChartBar.vue'

const kpiStore = useKpiStore()

const {
  kpiEventCreated,
  kpiEventDone,
  kpiEventCampaign,
  loadingEventCreatedKpi,
  loadingEventDoneKpi,
  loadingEventCampaignKpi,
  errorEventCreated,
  errorEventDone,
  errorEventCampaign,
  categoryColors,
} = storeToRefs(kpiStore)
</script>

<template>
  <!-- Legend for chart color categories -->
  <div class="flex gap-4 justify-center">
    <div v-for="key in Object.keys(categoryColors)" :key="key" class="flex gap-2 align-center">
      <div
        class="badge badge-xs self-center w-8 rounded-sm"
        :style="{ backgroundColor: categoryColors[key] }"
      ></div>
      {{ key }}
    </div>
  </div>

  <ChartBar
    :data="kpiEventCreated || []"
    title="Rendez-vous Créés"
    :loading="loadingEventCreatedKpi"
    :error="errorEventCreated"
  />
  <ChartBar
    :data="kpiEventDone || []"
    title="Rendez-vous Réalisés"
    :loading="loadingEventDoneKpi"
    :error="errorEventDone"
  />
  <ChartBar
    :data="kpiEventCampaign || []"
    title="Rendez-vous Campagnes"
    :loading="loadingEventCampaignKpi"
    :error="errorEventCampaign"
  />
</template>
